"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSecurityHeaders = exports.setNoCacheHeaders = exports.setResponseHeaders = void 0;
const web_headers_1 = require("@snapchat/web-headers");
const web_i18n_1 = require("@snapchat/web-i18n");
const requests_1 = require("./requests");
function setResponseHeaders(requestID, req, res, policyDirectives, stopCachingOnRequestsWithoutLocale) {
    if (req && res) {
        setSecurityHeaders(res, policyDirectives);
        (0, requests_1.setRequestIDIfPresent)(requestID, res);
        /**
         * For pages behind APIGW, APIGW doesnt add accept-lang header in the cache key (due to its high cardinality).
         * This means if we cache all requests, theoretically someone can get back the response in some other locale
         * just because that response was the latest cached one
         *
         * In such cases, we decided to not cache requests that do not have locale in their URL or sc-language cookie.
         * We can do so by not adding cache headers in the response.
         */
        if (stopCachingOnRequestsWithoutLocale && !(0, web_i18n_1.hasLocale)(req)) {
            (0, web_i18n_1.setSCLanguageCookieHeader)(req, res);
            setNoCacheHeaders(res);
        }
        else {
            setCacheHeaders(res);
        }
    }
}
exports.setResponseHeaders = setResponseHeaders;
const maxAgeMins = 5;
const maxAgeSecs = maxAgeMins * 60;
const cacheControl = `public,max-age=${maxAgeSecs}`;
function setCacheHeaders(res) {
    // next.js generates the ETag header for us:
    //  https://nextjs.org/docs/api-reference/next.config.js/disabling-etag-generation
    res.setHeader("Cache-Control", cacheControl);
}
function setNoCacheHeaders(res) {
    // Ask to not cache the page
    res.setHeader("Cache-Control", "max-age=0,no-cache,no-store");
}
exports.setNoCacheHeaders = setNoCacheHeaders;
// TODO: consider https://github.com/jagaapple/next-secure-headers
function setSecurityHeaders(res, policyDirectives) {
    res.setHeader("X-Frame-Options", "DENY");
    res.setHeader("X-XSS-Protection", "0");
    res.setHeader("Content-Security-Policy", (0, web_headers_1.generateCSPHeaderValue)(policyDirectives));
    res.setHeader("Strict-Transport-Security", "max-age=31536000"); // 1 year in seconds
}
exports.setSecurityHeaders = setSecurityHeaders;
//# sourceMappingURL=responses.js.map